import { Box, Card, CardContent, Grid, Skeleton, Stack } from '@mui/material';

/**
 * Content-shaped loading placeholders. Use instead of bare CircularProgress.
 *
 * @param {'page'|'table'|'cards'|'detail'} [variant='page']
 * @param {number} [rows=6]   — Row count for the table variant
 * @param {number} [cards=4]  — Tile count for the cards variant
 */
const LoadingSkeleton = ({ variant = 'page', rows = 6, cards = 4, sx }) => {
  if (variant === 'cards') {
    return (
      <Grid container spacing={2} sx={sx}>
        {Array.from({ length: cards }).map((_, i) => (
          <Grid key={i} size={{ xs: 6, sm: 4, lg: 12 / cards }}>
            <Card>
              <CardContent>
                <Skeleton width="55%" height={16} />
                <Skeleton width="70%" height={34} sx={{ mt: 0.5 }} />
                <Skeleton width="45%" height={14} sx={{ mt: 0.5 }} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  if (variant === 'table') {
    return (
      <Box sx={{ px: 2, py: 1.5, ...sx }}>
        <Stack direction="row" spacing={2} sx={{ mb: 1.5 }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} width={`${12 + (i % 3) * 6}%`} height={14} />
          ))}
        </Stack>
        {Array.from({ length: rows }).map((_, r) => (
          <Stack key={r} direction="row" spacing={2} sx={{ py: 1 }}>
            {Array.from({ length: 5 }).map((_, c) => (
              <Skeleton key={c} width={`${14 + ((r + c) % 3) * 5}%`} height={18} />
            ))}
          </Stack>
        ))}
      </Box>
    );
  }

  if (variant === 'detail') {
    return (
      <Box sx={sx}>
        <Skeleton width={260} height={30} sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {Array.from({ length: 8 }).map((_, i) => (
            <Grid key={i} size={{ xs: 6, sm: 3 }}>
              <Skeleton width="60%" height={14} />
              <Skeleton width="80%" height={20} />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  // page — header + KPI cards + table block
  return (
    <Box sx={sx}>
      <Skeleton width={220} height={32} sx={{ mb: 0.5 }} />
      <Skeleton width={320} height={18} sx={{ mb: 3 }} />
      <LoadingSkeleton variant="cards" sx={{ mb: 3 }} />
      <Card>
        <LoadingSkeleton variant="table" />
      </Card>
    </Box>
  );
};

export default LoadingSkeleton;
